import React from 'react';

interface InputProps {
  name: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: string;
  className?: string;
  readOnly?: boolean; 
  onClick?: () => void;
}

const InputField: React.FC<InputProps> = ({
  name,
  value,
  onChange,
  placeholder,
  type = 'text',
  className = '',
  readOnly = false,
  onClick,
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick(); 
    }
  };

  return (
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
      readOnly={readOnly} 
      onClick={handleClick}
    />
  );
};

export default InputField;